'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface LabLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: LabLayoutProps) {
    return <ServiceLayout>{children}</ServiceLayout>;
}
